import React, { useState, useEffect } from "react";
import Textfield from "@atlaskit/textfield";
import { setEditorSaved } from "../../../../../../../redux/actions/integrationActions";
import { useDispatch, useSelector } from "react-redux";
import PaginationTypeList from "./PaginationTypeList";
import PaginationEditor from "./PaginationEditor";
import Lozenge from "@atlaskit/lozenge";
import { setPaginationBreakJsonPath, setPaginationVariableName } from "./utils/paginationUtil";
import { Label } from "@atlaskit/form";
import PaginationStatus from "./PaginationStatus";
import ShowFullScopeVariablePathHint from "../../../extension/ShowFullScopeVariablePathHint";

const PaginationInput = ({ action }) => {
  const [variableName, setVariableName] = useState("page");
  const [breakingPath, setBreakingPath] = useState("$");
  const [paginationType, setPaginationType] = useState(action?.pagination?.type ?? null);

  const dispatch = useDispatch();
  const currentUrl = useSelector((state) => state.integration.currentUrl);

  useEffect(() => {
    if (action && action.pagination && action.pagination.variable) {
      setVariableName(action.pagination.variable.name ? action.pagination.variable.name : "");
    }
    if (action && action.pagination && action.pagination.breakJsonPath) {
      setBreakingPath(action.pagination.breakJsonPath ? action.pagination.breakJsonPath : "");
    }
    if (action && action.pagination === undefined) {
      setVariableName("page");
      setBreakingPath("$");
    }
    setPaginationType(action?.pagination?.type ?? null);
  }, [action, currentUrl]);

  const onChangeVariableName = (e) => {
    setVariableName(e.target.value);
    action.pagination = setPaginationVariableName(action.pagination, e.target.value);
    dispatch(setEditorSaved(false));
  };
  const onChangeBreakingPath = (e) => {
    setBreakingPath(e.target.value);
    action.pagination = setPaginationBreakJsonPath(action.pagination, e.target.value);
    dispatch(setEditorSaved(false));
  };

  const onPaginationTypeChange = (type) => {
    setPaginationType(type);
  };
  const bakeURL = () => {
    if (currentUrl) {
      return currentUrl;
    } else if (action && action.url) {
      return action.url;
    }
    return "NO URL FOUND";
  };

  return (
    <>
      <p className="ihub-action-tab-description">
        Pagination handles data delivered in parts, or "pages." With this setting, the system will continue collecting data until:
      </p>
      <ul>
        <li>No new data is received.</li>
        <li>The same data is received twice.</li>
        <li>No further updates are available.</li>
        <li>A defined stopping point is reached.</li>
      </ul>
      <p>This ensures that all available data is collected without missing any pages.</p>
      <ShowFullScopeVariablePathHint />
      Enabled:
      <PaginationStatus action={action} />
      <br />
      <Label>
        URL Preview:
        <Lozenge appearance="inprogress" maxWidth={1000}>
          {bakeURL()}
        </Lozenge>
      </Label>
      <hr />
      <Label>Pagination variable name:</Label>
      <Textfield value={variableName} isCompact onChange={onChangeVariableName} />
      <Label>Pagination type:</Label>
      <PaginationTypeList action={action} paginationType={paginationType} onPaginationTypeChange={onPaginationTypeChange} />
      <PaginationEditor action={action} paginationType={paginationType} variableName={variableName} />
      <hr />
      <Label>Breaking path - JSON Path to array of result(s) or count that indicates no more results:</Label>
      <Textfield value={breakingPath} isCompact onChange={onChangeBreakingPath} />
    </>
  );
};

export default PaginationInput;
